export const challenges = {
  appBarTitle: "Challenges",
  addChallenge: "Add Challenge",
  noChallenges: "No challenges yet",
  challengesPerPage: "Challenges per page",

  tabs: {
    started: "Started",
    pending: "Pending",
    expired: "Expired",
  },

  status: {
    pending: "Pending",
    started: "Started",
    ended: "Ended",
    draft: "Draft",
  },

  type: {
    promo: "Promo Challenge",
    quick: "Quick Challenge",
  },

  targetPersonas: {
    fo: "Fleet Owner",
    so: "Single Owner",
    driver: "Driver",
  },

  rewardTypes: {
    air_recharge: "Air Recharge",
  },

  userStatus: {
    inProgress: "In Progress",
    urgent: "Urgent",
    awaitingReview: "Awaiting Review",
    outOfCap: "Out of Cap",
    won: "Won",
    notQualified: "Not Qualified",
  },

  rewardStatus: {
    pendingSelection: "Pending Selection",
    selected: "Selected",
    redeemed: "Redeemed",
    expiredNotSelected: "Expired — Not Selected",
    expiredNotRedeemed: "Expired — Not Redeemed",
    failedAdminReview: "Failed — Admin Review",
  },

  winnerStatus: {
    winner: "Winner",
    nonWinner: "Non-Winner",
    notQualified: "Not Qualified",
  },

  card: {
    view: "View",
    edit: "Edit",
    duplicate: "Duplicate",
    deleteDraft: "Delete Draft",
    publish: "Publish",
    unpublish: "Unpublish",
    published: "Published",
    unpublished: "Unpublished",
    starts: "Starts",
    ends: "Ends",
    winner: "Winner",
    winners: "Winners",
    currency: "EGP",
    reward: "Reward",
    cap: "Cap",
    rewardSubmitted: "Submitted",
  },

  publishChallenge: "Publish Challenge",
  publishConfirm:
    "Publishing will make this challenge visible to eligible users. Are you sure?",
  unpublishChallenge: "Unpublish Challenge",
  unpublishConfirm:
    "Unpublishing will hide this challenge from users. In-flight progress is preserved. Are you sure?",
  duplicateChallenge: "Duplicate Challenge",
  duplicateConfirm:
    "This will create a draft copy of the challenge. Are you sure?",
  deleteDraft: "Delete Draft",
  deleteDraftConfirm: "This will permanently delete this draft. Are you sure?",
  editBlockedEnded: "Ended challenges cannot be edited.",

  challengeForm: {
    createTitle: "Add Challenge",
    editTitle: "Edit Challenge",
    duplicateTitle: "Duplicate Challenge",
    create: "Create Challenge",
    edit: "Edit",
    duplicate: "Duplicate Challenge",
    saveAsDraft: "Save as Draft",
    challengeType: "Challenge Type",
    duration: "Duration & Targeting",
    bannerAssets: "Banner Assets",
    content: "Challenge Content",
    rewardConfig: "Reward Configuration",
    subTasks: "Sub-tasks",
    notificationCopy: "Notifications",
    notificationTypes: {
      start_quick_challenge: "Publishing",
      mid_quick_challenge: "Mid-Way Reminder",
      last_day_quick_challenge: "Last-Day Reminder",
      winner: "Winners",
      non_winner: "Non-Winners",
    },
    challengeName: "Challenge Name",
    targetPersona: "Target Persona",
    startDate: "Start Date",
    endDate: "End Date",
    homeBanner: "Home Banner",
    popupBanner: "Popup Banner",
    homeBannerRatio: "(8:3)",
    popupBannerRatio: "(4:3)",
    requiresMobilawy: "Requires Mobilawy Wallet",
    internalNameEn: "Internal BE Name in English",
    internalNameAr: "Internal BE Name in Arabic",
    quickChallengeTitleEn: "Quick Challenge Title in English",
    quickChallengeTitleAr: "Quick Challenge Title in Arabic",
    promotionTitleEn: "Quick Challenge Title in English",
    promotionTitleAr: "Quick Challenge Title in Arabic",
    promotionNameEn: "Promotion Name in English",
    promotionNameAr: "Promotion Name in Arabic",
    rewardPhoto: "Reward Photo",
    rewardType: "Reward Type",
    rewardValue: "Reward Value (EGP)",
    numberOfWinners: "Number of Winners",
    displayLabelEn: "Display Label in English",
    displayLabelAr: "Display Label in Arabic",
    configureReward: "Configure Reward",
    editReward: "Edit Reward",
    noRewardConfigured: "No reward configured",
    subTasksNoPersona: "Select at least one target persona to configure sub-tasks.",
    subTask: "Sub-task",
    noSubTasksYet: "No sub-tasks added yet.",
    addSubTask: "Add Sub-task",
    subTaskNameEn: "Sub-task Name in English",
    subTaskNameAr: "Sub-task Name in Arabic",
    signalType: "Signal Type",
    targetValue: "Target Value",
    withinDuration: "Within Duration",
    shortDescEn: "Short Description in English",
    shortDescAr: "Short Description in Arabic",
    howToWinEn: "How-to-Win Text in English",
    howToWinAr: "How-to-Win Text in Arabic",
    ctaCopyEn: "CTA in English",
    ctaCopyAr: "CTA in Arabic",
    endDateInfoEn: "End-date Info in English",
    endDateInfoAr: "End-date Info in Arabic",
    howToWinTitleEn: "How-to-Win Title in English",
    howToWinTitleAr: "How-to-Win Title in Arabic",
    detailInfo: "Detail Info",
    howToWinInfoEn: "How-to-Win Info in English",
    howToWinInfoAr: "How-to-Win Info in Arabic",
    rewardInfoEn: "Reward Info in English",
    rewardInfoAr: "Reward Info in Arabic",
    tcInfoEn: "Terms & Conditions in English",
    tcInfoAr: "Terms & Conditions in Arabic",
    publishingNotifTitleEn: "Title in English",
    publishingNotifTitleAr: "Title in Arabic",
    publishingNotifBodyEn: "Body in English",
    publishingNotifBodyAr: "Body in Arabic",
    reminderNotifTitleEn: "Title in English",
    reminderNotifTitleAr: "Title in Arabic",
    reminderNotifBodyEn: "Body in English",
    reminderNotifBodyAr: "Body in Arabic",
    lastDayNotifTitleEn: "Title in English",
    lastDayNotifTitleAr: "Title in Arabic",
    lastDayNotifBodyEn: "Body in English",
    lastDayNotifBodyAr: "Body in Arabic",
    winnersNotifTitleEn: "Title in English",
    winnersNotifTitleAr: "Title in Arabic",
    winnersNotifBodyEn: "Body in English",
    winnersNotifBodyAr: "Body in Arabic",
    nonWinnersNotifTitleEn: "Title in English",
    nonWinnersNotifTitleAr: "Title in Arabic",
    nonWinnersNotifBodyEn: "Body in English",
    nonWinnersNotifBodyAr: "Body in Arabic",
    confirm: "Confirm",
    cancel: "Cancel",
    personaSwitchConfirm: "Remove",
    personaSwitchTitle: "Remove persona?",
    personaSwitchDescription: "This persona has sub-tasks with data filled in. Removing it will discard that data. Continue?",

    // Persona labels
    personas: {
      fo: "Fleet Owner",
      so: "Single Owner",
      driver: "Driver",
    },

    // Signal types labels
    signalTypes: {
      kyc: "KYC",
      referral: "Referral",
      addVehicle: "Add Vehicle",
      addDriver: "Add Driver",
      addMaintenance: "Add Expense",
      coveredKm: "Covered Km",
      joinFleet: "Join Fleet",
      level: "Level",
    },

    // Validation messages
    validation: {
      promotionTitleEnReq: "Quick Challenge title in English is required",
      promotionTitleEnValid:
        "Quick Challenge title in English contains invalid characters",
      promotionTitleEnMax:
        "Quick Challenge title in English must be 30 characters or fewer",
      promotionTitleArReq: "Quick Challenge title in Arabic is required",
      promotionTitleArValid:
        "Quick Challenge title in Arabic contains invalid characters",
      promotionTitleArMax:
        "Quick Challenge title in Arabic must be 30 characters or fewer",
      startDateReq: "Start date is required",
      startDateValid: "Start date must be a valid date",
      startDateMin: "Start date must be a future date (after today)",
      endDateReq: "End date is required",
      endDateValid: "End date must be a valid date",
      endDateMin: "End date must be on or after the start date",
      targetPersonasReq: "Select at least one target persona",
      numberOfWinnersReq: "Number of winners is required",
      numberOfWinnersPositive: "Number of winners must be a positive number",
      numberOfWinnersInteger: "Number of winners must be a whole number",
      numberOfWinnersTypeError:
        "Number of winners should only contain numbers",
      numberOfWinnersMax: "Number of winners must be 9999 or fewer",
      numberOfWinnersCapDecrease:
        "The number of winners can only be increased once a challenge has started",
      howToWinEnReq: "How-to-Win text in English is required",
      howToWinEnValid: "How-to-Win text in English contains invalid characters",
      howToWinEnMax:
        "How-to-Win text in English must be 150 characters or fewer",
      howToWinArReq: "How-to-Win text in Arabic is required",
      howToWinArValid: "How-to-Win text in Arabic contains invalid characters",
      howToWinArMax:
        "How-to-Win text in Arabic must be 150 characters or fewer",
      shortDescEnReq: "Short description in English is required",
      shortDescEnValid:
        "Short description in English contains invalid characters",
      shortDescEnMax:
        "Short description in English must be 80 characters or fewer",
      shortDescArReq: "Short description in Arabic is required",
      shortDescArValid:
        "Short description in Arabic contains invalid characters",
      shortDescArMax:
        "Short description in Arabic must be 80 characters or fewer",
      ctaCopyEnReq: "CTA copy in English is required",
      ctaCopyEnValid: "CTA copy in English contains invalid characters",
      ctaCopyEnMax: "CTA copy in English must be 25 characters or fewer",
      ctaCopyArReq: "CTA copy in Arabic is required",
      ctaCopyArValid: "CTA copy in Arabic contains invalid characters",
      ctaCopyArMax: "CTA copy in Arabic must be 25 characters or fewer",
      rewardReq: "Reward configuration is required",
      rewardTypeReq: "Reward type is required",
      rewardStatusReq: "Reward status is required",
      requiredPointsReq: "Required points is required",
      requiredPointsPositive: "Required points must be greater than 0",
      rewardValueReq: "Reward value is required",
      rewardValuePositive: "Reward value must be a positive number",
      displayLabelEnReq: "Display label in English is required",
      displayLabelEnMax:
        "Display label in English must be 100 characters or fewer",
      displayLabelArReq: "Display label in Arabic is required",
      displayLabelArMax:
        "Display label in Arabic must be 100 characters or fewer",
      subTasksMin: "Add at least one sub-task",
      subTasksMax: "Maximum 3 sub-tasks allowed",
      subTasksFieldsInvalid: "All sub-task fields (name, signal type, target value) are required",
      publishingNotifTitleEnReq: "Publishing notification title in English is required",
      publishingNotifTitleEnValid: "Publishing notification title in English contains invalid characters",
      publishingNotifTitleArReq: "Publishing notification title in Arabic is required",
      publishingNotifTitleArValid: "Publishing notification title in Arabic contains invalid characters",
      publishingNotifBodyEnReq: "Publishing notification body in English is required",
      publishingNotifBodyEnValid: "Publishing notification body in English contains invalid characters",
      publishingNotifBodyArReq: "Publishing notification body in Arabic is required",
      publishingNotifBodyArValid: "Publishing notification body in Arabic contains invalid characters",
      reminderNotifTitleEnReq: "Reminder notification title in English is required",
      reminderNotifTitleEnValid: "Reminder notification title in English contains invalid characters",
      reminderNotifTitleArReq: "Reminder notification title in Arabic is required",
      reminderNotifTitleArValid: "Reminder notification title in Arabic contains invalid characters",
      reminderNotifBodyEnReq: "Reminder notification body in English is required",
      reminderNotifBodyEnValid: "Reminder notification body in English contains invalid characters",
      reminderNotifBodyArReq: "Reminder notification body in Arabic is required",
      reminderNotifBodyArValid: "Reminder notification body in Arabic contains invalid characters",
      lastDayNotifTitleEnReq: "Last day notification title in English is required",
      lastDayNotifTitleEnValid: "Last day notification title in English contains invalid characters",
      lastDayNotifTitleArReq: "Last day notification title in Arabic is required",
      lastDayNotifTitleArValid: "Last day notification title in Arabic contains invalid characters",
      lastDayNotifBodyEnReq: "Last day notification body in English is required",
      lastDayNotifBodyEnValid: "Last day notification body in English contains invalid characters",
      lastDayNotifBodyArReq: "Last day notification body in Arabic is required",
      lastDayNotifBodyArValid: "Last day notification body in Arabic contains invalid characters",
      winnersNotifTitleEnReq: "Winners notification title in English is required",
      winnersNotifTitleEnValid: "Winners notification title in English contains invalid characters",
      winnersNotifTitleArReq: "Winners notification title in Arabic is required",
      winnersNotifTitleArValid: "Winners notification title in Arabic contains invalid characters",
      winnersNotifBodyEnReq: "Winners notification body in English is required",
      winnersNotifBodyEnValid: "Winners notification body in English contains invalid characters",
      winnersNotifBodyArReq: "Winners notification body in Arabic is required",
      winnersNotifBodyArValid: "Winners notification body in Arabic contains invalid characters",
      nonWinnersNotifTitleEnReq: "Non-winners notification title in English is required",
      nonWinnersNotifTitleEnValid: "Non-winners notification title in English contains invalid characters",
      nonWinnersNotifTitleArReq: "Non-winners notification title in Arabic is required",
      nonWinnersNotifTitleArValid: "Non-winners notification title in Arabic contains invalid characters",
      nonWinnersNotifBodyEnReq: "Non-winners notification body in English is required",
      nonWinnersNotifBodyEnValid: "Non-winners notification body in English contains invalid characters",
      nonWinnersNotifBodyArReq: "Non-winners notification body in Arabic is required",
      nonWinnersNotifBodyArValid: "Non-winners notification body in Arabic contains invalid characters",
      publishingNotifTitleEnMax: "Publishing notification title in English must be 50 characters or fewer",
      publishingNotifTitleArMax: "Publishing notification title in Arabic must be 50 characters or fewer",
      publishingNotifBodyEnMax: "Publishing notification body in English must be 250 characters or fewer",
      publishingNotifBodyArMax: "Publishing notification body in Arabic must be 250 characters or fewer",
      reminderNotifTitleEnMax: "Reminder notification title in English must be 50 characters or fewer",
      reminderNotifTitleArMax: "Reminder notification title in Arabic must be 50 characters or fewer",
      reminderNotifBodyEnMax: "Reminder notification body in English must be 250 characters or fewer",
      reminderNotifBodyArMax: "Reminder notification body in Arabic must be 250 characters or fewer",
      lastDayNotifTitleEnMax: "Last day notification title in English must be 50 characters or fewer",
      lastDayNotifTitleArMax: "Last day notification title in Arabic must be 50 characters or fewer",
      lastDayNotifBodyEnMax: "Last day notification body in English must be 250 characters or fewer",
      lastDayNotifBodyArMax: "Last day notification body in Arabic must be 250 characters or fewer",
      winnersNotifTitleEnMax: "Winners notification title in English must be 50 characters or fewer",
      winnersNotifTitleArMax: "Winners notification title in Arabic must be 50 characters or fewer",
      winnersNotifBodyEnMax: "Winners notification body in English must be 250 characters or fewer",
      winnersNotifBodyArMax: "Winners notification body in Arabic must be 250 characters or fewer",
      nonWinnersNotifTitleEnMax: "Non-winners notification title in English must be 50 characters or fewer",
      nonWinnersNotifTitleArMax: "Non-winners notification title in Arabic must be 50 characters or fewer",
      nonWinnersNotifBodyEnMax: "Non-winners notification body in English must be 250 characters or fewer",
      nonWinnersNotifBodyArMax: "Non-winners notification body in Arabic must be 250 characters or fewer",
      rewardInfoEnMax: "Reward info must be 5000 characters or fewer",
      rewardInfoArMax: "Reward info must be 5000 characters or fewer",
      tcInfoEnMax: "Terms & Conditions must be 5000 characters or fewer",
      tcInfoArMax: "Terms & Conditions must be 5000 characters or fewer",
      endDateInfoEnMax: "End-date info must be 500 characters or fewer",
      endDateInfoArMax: "End-date info must be 500 characters or fewer",
      howToWinTitleEnMax: "How-to-Win title must be 160 characters or fewer",
      howToWinTitleArMax: "How-to-Win title must be 160 characters or fewer",
      howToWinInfoEnMax: "How-to-Win info must be 5000 characters or fewer",
      howToWinInfoArMax: "How-to-Win info must be 5000 characters or fewer",
      subTaskNameEnReq: "Sub-task name in English is required",
      subTaskNameEnValid: "Sub-task name in English must contain English characters only",
      subTaskNameEnMax: "Sub-task name in English must be 31 characters or fewer",
      subTaskNameArReq: "Sub-task name in Arabic is required",
      subTaskNameArValid: "Sub-task name in Arabic must contain Arabic characters only",
      subTaskNameArMax: "Sub-task name in Arabic must be 31 characters or fewer",
      subTaskSignalTypeReq: "Signal type is required",
      subTaskTargetValueReq: "Target value is required",
      subTaskTargetValueTypeError: "Target value must be a number",
      subTaskTargetValuePositive: "Target value must be a positive number",
      subTaskTargetValueInteger: "Target value must be a whole number",
      subTaskTargetValueMax: "Target value must be {max} or fewer",
      subTaskLevelReq: "Level is required",
    },
  },

  challengeDetails: {
    challengeDetailsTitle: "Quick Challenge Details",
    editChallengeTooltip: "Expired challenges can't be edited",
    challengeInfo: "Challenge Info",
    liveProgress: "Live Progress",
    winnerCap: "Winner Cap",
    published: "Published",
    unpublished: "Unpublished",
    endsIn: "Ends in {days} days",
    endsToday: "Ends today",
    ended: "Ended",
    starts: "Starts",
    ends: "Ends",
    typeLabel: "Type",
    audience: "Target Persona(s)",
    startDate: "Start Date",
    endDate: "End Date",
    daysLeft: "{days} days left",
    dayLeft: "1 day left",
    winnersTowardCap: "Winners toward cap",
    ofCap: "of {cap} cap",
    personas: {
      fo: "Fleet Owner",
      so: "Single Owner",
      driver: "Driver",
    },
    descriptionEn: "Description in English",
    descriptionAr: "Description in Arabic",
    howToWinEn: "How to Win in English",
    howToWinAr: "How to Win in Arabic",
    ctaEn: "CTA Copy in English",
    ctaAr: "CTA Copy in Arabic",
    reward: "Reward",
    rewardChannel: "Reward Channel",
    rewardImage: "Reward Image",
    subTasks: "Sub-tasks",
    subTaskTarget: "Target",
    subTaskUserType: "User Type",
    subTaskType: "Type",
    subTaskCountOne: "1 sub-task",
    subTaskCountMany: "{count} sub-tasks",
    titleEn: "Title in English",
    titleAr: "Title in Arabic",
    bodyEn: "Body in English",
    bodyAr: "Body in Arabic",
    duringPromo: "Within Duration",
    signalTypes: {
      kyc: "KYC",
      referral: "Referral",
      add_vehicle: "Add Vehicle",
      add_driver: "Add Driver",
      add_maintenance: "Add Expense",
      covered_km: "Covered KM",
      join_fleet: "Join Fleet",
      level: "Level",
    },
    notifications: "Notifications",
    na: "—",
    rewardTypes: {
      air_recharge: "Air Recharge",
    },
    notificationTypes: {
      start_quick_challenge: "Publishing",
      mid_quick_challenge: "Mid-Way Reminder",
      last_day_quick_challenge: "Last-Day Reminder",
      winner: "Winners",
      non_winner: "Non-Winners",
    },
    participants: "Participants",
    completions: "Completions",
    winners: "Winners",
    usersTab: "Users",
    rewardsTab: "Rewards",
    auditTab: "Winner Audit",
    noUsers: "No users completed this challenge yet",
    noRewards: "No rewards submitted yet",
  },

  usersAnalytics: {
    totalWinners: "Total Winners",
    totalCompleted: "Total Completed",
    totalNonWinners: "Total Non-Winners",
    totalParticipants: "Total Participants",
    deletedWinners: "Deleted Winners",
  },

  rewardsAnalytics: {
    totalEarned: "Total Earned",
    totalRedeemed: "Total Redeemed",
    pendingSelection: "Pending Selection",
    selected: "Selected",
    expiredNotSelected: "Expired — Not Selected",
    expiredNotRedeemed: "Expired — Not Redeemed",
  },

  winnerAudit: {
    title: "Winner Audit",
    qualifiedUsers: "Qualified Users",
    fraudFilter: "Show Fraud-Flagged Only",
    submitRewards: "Submit Rewards",
    submitConfirm:
      "This will disburse Fawry Air Recharge rewards to all selected users. This action cannot be undone. Are you sure?",
    deselect: "Deselect",
    rank: "Rank",
  },

  participantsList: {
    sectionTitle: "Challenge Participants",
    searchPlaceholder: "Search by name or phone number",
    personaLabel: "Persona",
    allPersonas: "All Personas",
    completionDateLabel: "Completion Date",
    noResults: "No participants match your filters",
    columns: {
      rank: "Rank",
      displayName: "Display Name",
      persona: "Persona",
      phoneNumber: "Phone Number",
      completedAt: "Completion Timestamp",
      fraudFlag: "Fraud Flag",
      status: "Status",
    },
    selectedCount: "{selected} of {total} selected",
    submitSelection: "Submit Selection",
    submitSelectionConfirm:
      "This will lock in the selected winners for reward assignment. Are you sure?",
    submitSelectionSuccess: "Selection submitted successfully",
    outOfCapTooltip: "Above the winner cap — not selectable",
    notQualifiedTooltip: "Not qualified for a reward — not selectable",
    deletedUserTooltip: "Deleted users can't be selected",
  },

  rewardsList: {
    sectionTitle: "Challenge Rewards",
    searchPlaceholder: "Search by name or phone number",
    personaLabel: "Persona",
    allPersonas: "All Personas",
    statusLabel: "Reward Status",
    allStatuses: "All Statuses",
    noResults: "No rewards match your filters",
    columns: {
      displayName: "Display Name",
      persona: "Persona",
      phoneNumber: "Phone Number",
      rewardAmount: "Reward Amount",
      status: "Reward Status",
      selectionExpiresAt: "Selection Expiry",
      redemptionExpiresAt: "Redemption Expiry",
    },
    status: {
      earned: "Earned",
      selected: "Selected",
      redeeming: "Redeeming",
      redeemed: "Redeemed",
      selection_expired: "Selection Expired",
      redemption_expired: "Redemption Expired",
    },
    analytics: {
      totalEarned: "Total Earned",
      pendingSelection: "Pending Selection",
      selected: "Selected",
      totalRedeemed: "Total Redeemed",
      expiredNotSelected: "Expired (Not Selected)",
      expiredNotRedeemed: "Expired (Not Redeemed)",
    },
  },
};
